import template from './license-button.html';
import controller from './license-button.controller';

const LicenseButtonComponent = {
    template,
    controller,
    bindings: {
        companyId: '<',
        saved: '&',
        modalAppendTo: '@'
    },
};

export default LicenseButtonComponent;



// WEBPACK FOOTER //
// ./components/popups/license-popup/button/license-button.component.js